import React, { useState, Fragment, useEffect } from 'react';
import {
    Button, Box, Grid, Paper, CircularProgress, TextField, Typography, Divider, Checkbox, FormControlLabel,
    MenuItem,
    Select, FormControl, InputLabel, ToggleButton, ToggleButtonGroup,
    Accordion, AccordionSummary, AccordionDetails,
} from '@mui/material';

import { useNotify } from 'react-admin';
import Dropzone from 'react-dropzone'

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import UpdateIcon from '@mui/icons-material/Update';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import VerticalAlignCenterIcon from '@mui/icons-material/VerticalAlignCenter';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import SwapVerticalCircleIcon from '@mui/icons-material/SwapVerticalCircle';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import GridOnIcon from '@mui/icons-material/GridOn';
import ViewArrayIcon from '@mui/icons-material/ViewArray';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import DnsIcon from '@mui/icons-material/Dns';
import LabelIcon from '@mui/icons-material/Label';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import TextRotationAngleupIcon from '@mui/icons-material/TextRotationAngleup';
import InputIcon from '@mui/icons-material/Input';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import SignalCellular1BarIcon from '@mui/icons-material/SignalCellular1Bar';
import CopyrightIcon from '@mui/icons-material/Copyright';
import TransitEnterexitIcon from '@mui/icons-material/TransitEnterexit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/theme-github";

import Help from '../component/Help';
import client from '../common/client';
import NodeSelectInput from './NodeSelectInput'
import NodeUdidSelectInput from './NodeUdidSelectInput'
import JsonPathInput from './JsonPathInput'
import IfExpressInput from './IfExpressInput'

const sx = {
    root: {
        display: 'flex',
        alignItems: 'center'
    }
}

const EachInput = ({ m, index, handleOnChange, handleOnChangeCheckbox, valueSetFunction, valueFunction, sketchJson, targetNode, onLoad }) => {
    return (
        <Box mt={1} sx={sx}>
            {m.type == 'node' &&
                <NodeSelectInput label={m.label} value={valueFunction(index)} onChange={(v) => handleOnChange(null, valueSetFunction(index), v)}
                    sketchJson={sketchJson} targetNode={targetNode} />
            }
            {m.type == 'text' &&
                <TextField label={m.label} value={valueFunction(index)} onChange={(e) => handleOnChange(e, valueSetFunction(index))} />
            }
            {m.type == 'check' &&
                <FormControlLabel
                    control={<Checkbox color="primary"
                        checked={valueFunction(index) == 'Y'}
                        onChange={(e) => { return handleOnChangeCheckbox(e, valueSetFunction(index)) }}
                    />}
                    label={m.label}
                    labelPlacement="end"
                />
            }
            {m.type == 'select' &&
                <FormControl fullWidth>
                    <InputLabel>{m.label}</InputLabel>
                    <Select
                        value={valueFunction(index)}
                        label={m.label}
                        defaultValue={m.defaultValue}
                        onChange={(e) => handleOnChange(e, valueSetFunction(index))}
                    >
                        {m.values.map(a => (
                            <MenuItem value={a.v}>{a.v}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
            {m.type == 'script' &&
                <AceEditor
                    width={'100%'}
                    height={"250px"}
                    placeholder={m.label}
                    mode="javascript"
                    theme="github"
                    name="blah2"
                    onLoad={onLoad}
                    onChange={newValue => {
                        let f = valueSetFunction(index)
                        f(newValue)
                    }
                    }
                    fontSize={14}
                    showPrintMargin={true}
                    showGutter={true}
                    highlightActiveLine={true}
                    value={valueFunction(index)}
                    setOptions={{
                        enableBasicAutocompletion: false,
                        enableLiveAutocompletion: false,
                        enableSnippets: false,
                        showLineNumbers: true,
                        tabSize: 2,
                    }} />
            }
        </Box>
    )
}

const RulePannel = props => {
    const [loadingAdd, setLoadingAdd] = useState(false);
    const [loadingUpdate, setLoadingUpdate] = useState(false);

    const [sketchUdid, setSketchUdid] = React.useState(null);
    const [sketchJson, setSketchJson] = React.useState({});
    const [targetNode, setTargetNode] = React.useState(null);
    const [errorMsg, setErrorMsg] = React.useState(null);

    const notify = useNotify();

    const [select1, setSelect1] = useState('')
    const [select2, setSelect2] = useState('')
    const [select3, setSelect3] = useState('')
    const [select4, setSelect4] = useState('')
    const [select5, setSelect5] = useState('')
    const [select6, setSelect6] = useState('')
    const [select7, setSelect7] = useState('')
    const [select8, setSelect8] = useState('')
    const [select9, setSelect9] = useState('')
    const [select10, setSelect10] = useState('')
    const [select11, setSelect11] = useState('')
    const [select12, setSelect12] = useState('')
    const [select13, setSelect13] = useState('')
    const [select14, setSelect14] = useState('')
    const [select15, setSelect15] = useState('')
    const [select16, setSelect16] = useState('')
    const [select17, setSelect17] = useState('')
    const [select18, setSelect18] = useState('')
    const [select19, setSelect19] = useState('')
    const [select20, setSelect20] = useState('')
    const [select21, setSelect21] = useState('')
    const [select22, setSelect22] = useState('')
    const [select23, setSelect23] = useState('')
    const [select24, setSelect24] = useState('')
    const [select25, setSelect25] = useState('')
    const [select26, setSelect26] = useState('')
    const [select27, setSelect27] = useState('')
    const [select28, setSelect28] = useState('')
    const [select29, setSelect29] = useState('')
    const [select30, setSelect30] = useState('')
    const [select31, setSelect31] = useState('')
    const [select32, setSelect32] = useState('')
    const [select33, setSelect33] = useState('')
    const [select34, setSelect34] = useState('')
    const [select35, setSelect35] = useState('')
    const [select36, setSelect36] = useState('')

    const [fileRaw, setFileRaw] = useState(null)

    const handleOnChange = (e, setter, v) => {
        if (v || v == '')
            setter(v)
        else
            setter(e.target.value)
    }
    const handleOnChangeCheckbox = (e, setter) => {
        if (e.target.checked == true || e.target.checked == false)
            setter(e.target.checked ? 'Y' : 'N')
    }

    const findNodeRecur = (sketch_json, node_udid) => {
        if (node_udid != null && sketch_json.do_objectID == node_udid) {
            return sketch_json
        }
        for (let i = 0; sketch_json.layers && i < sketch_json.layers.length; i++) {
            let r = findNodeRecur(sketch_json.layers[i], node_udid)
            if (r)
                return r
        }
        return null
    }

    useEffect(() => {
        // console.log('props.ruleInstance', props.ruleInstance)
        // console.log('props.rule', props.rule)
        if (props.ruleInstance) {
            setSelect1(props.ruleInstance.select1)
            setSelect2(props.ruleInstance.select2)
            setSelect3(props.ruleInstance.select3)
            setSelect4(props.ruleInstance.select4)
            setSelect5(props.ruleInstance.select5)
            setSelect6(props.ruleInstance.select6)
            setSelect7(props.ruleInstance.select7)
            setSelect8(props.ruleInstance.select8)
            setSelect9(props.ruleInstance.select9)
            setSelect10(props.ruleInstance.select10)
            setSelect11(props.ruleInstance.select11)
            setSelect12(props.ruleInstance.select12)
            setSelect13(props.ruleInstance.select13)
            setSelect14(props.ruleInstance.select14)
            setSelect15(props.ruleInstance.select15)
            setSelect16(props.ruleInstance.select16)
            setSelect17(props.ruleInstance.select17)
            setSelect18(props.ruleInstance.select18)
            setSelect19(props.ruleInstance.select19)
            setSelect20(props.ruleInstance.select20)
            setSelect21(props.ruleInstance.select21)
            setSelect22(props.ruleInstance.select22)
            setSelect23(props.ruleInstance.select23)
            setSelect24(props.ruleInstance.select24)
            setSelect25(props.ruleInstance.select25)
            setSelect26(props.ruleInstance.select26)
            setSelect27(props.ruleInstance.select27)
            setSelect28(props.ruleInstance.select28)
            setSelect29(props.ruleInstance.select29)
            setSelect30(props.ruleInstance.select30)
            setSelect31(props.ruleInstance.select31)
            setSelect32(props.ruleInstance.select32)
            setSelect33(props.ruleInstance.select33)
            setSelect34(props.ruleInstance.select34)
            setSelect35(props.ruleInstance.select35)
            setSelect36(props.ruleInstance.select36)
        } else {
            setSelect1('')
            setSelect2('')
            setSelect3('')
            setSelect4('')
            setSelect5('')
            setSelect6('')
            setSelect7('')
            setSelect8('')
            setSelect9('')
            setSelect10('')
            setSelect11('')
            setSelect12('')
            setSelect13('')
            setSelect14('')
            setSelect15('')
            setSelect16('')
            setSelect17('')
            setSelect18('')
            setSelect19('')
            setSelect20('')
            setSelect21('')
            setSelect22('')
            setSelect23('')
            setSelect24('')
            setSelect25('')
            setSelect26('')
            setSelect27('')
            setSelect28('')
            setSelect29('')
            setSelect30('')
            setSelect31('')
            setSelect32('')
            setSelect33('')
            setSelect34('')
            setSelect35('')
            setSelect36('')
        }

        if (props.sketchUdid && (props.sketchUdid != sketchUdid || props.targetNode != targetNode)) {
            setSketchUdid(props.sketchUdid)
            setTargetNode(props.targetNode)
            client.request_get(`/sketch/${props.sketchUdid}`).then(res => {
                setSketchJson(res.selectable_sketch_json)
                let target = findNodeRecur(res.selectable_sketch_json, props.targetNode)
                if (target || props.targetNode == null) {
                    setErrorMsg(null)
                } else {
                    setErrorMsg('Target Node is not exists. Did you remove or copy node(Udid changed)?')
                }
            });
        }

        if (props.rule.type.includes('.')) {
            setDynamicRuleLoading(true)
            client.request_get(`/api/rule/meta/${props.rule.type}`).then(rule_res => {
                if (rule_res) {
                    setDynamicRuleLoading(false)
                    setDynamicRule(rule_res.rule)
                }
            })
        }
    }, [props.ruleInstance, props.sketchUdid, props.targetNode, props.rule])

    const handleAdd = (event) => {
        setLoadingAdd(true)
        client.request_post(`/api/rule/insert`, {
            block_id: props.block_id,
            type: props.rule.type,
            select1: select1,
            select2: select2,
            select3: select3,
            select4: select4,
            select5: select5,
            select6: select6,
            select7: select7,
            select8: select8,
            select9: select9,
            select10: select10,
            select11: select11,
            select12: select12,
            select13: select13,
            select14: select14,
            select15: select15,
            select16: select16,
            select17: select17,
            select18: select18,
            select19: select19,
            select20: select20,
            select21: select21,
            select22: select22,
            select23: select23,
            select24: select24,
            select25: select25,
            select26: select26,
            select27: select27,
            select28: select28,
            select29: select29,
            select30: select30,
            select31: select31,
            select32: select32,
            select33: select33,
            select34: select34,
            select35: select35,
            select36: select36,
            fileRaw: fileRaw,
        }).then(res => {
            setLoadingAdd(false)
            if (res.r) {
                notify('Rule Added')
                if (props.changed)
                    props.changed()
            } else
                notify(res.msg, 'error')

        }).catch(e => {
            setLoadingAdd(false)
            notify(e)
        })
    };
    const handleUpdate = (event) => {
        setLoadingUpdate(true)
        client.request_post(`/api/rule/update/${props.ruleInstance.id}`, {
            block_id: props.block_id,
            type: props.rule.type,
            select1: select1,
            select2: select2,
            select3: select3,
            select4: select4,
            select5: select5,
            select6: select6,
            select7: select7,
            select8: select8,
            select9: select9,
            select10: select10,
            select11: select11,
            select12: select12,
            select13: select13,
            select14: select14,
            select15: select15,
            select16: select16,
            select17: select17,
            select18: select18,
            select19: select19,
            select20: select20,
            select21: select21,
            select22: select22,
            select23: select23,
            select24: select24,
            select25: select25,
            select26: select26,
            select27: select27,
            select28: select28,
            select29: select29,
            select30: select30,
            select31: select31,
            select32: select32,
            select33: select33,
            select34: select34,
            select35: select35,
            select36: select36,
            fileRaw: fileRaw,
        }).then(res => {
            setLoadingUpdate(false)
            if (res.r) {
                notify('Rule Updated')
                if (props.changed)
                    props.changed()
            } else
                notify(res.msg)

        }).catch(e => {
            setLoadingUpdate(false)
            notify('Update Failed')
        })
    };

    function onLoad(newValue) {
        console.log("onLoad", newValue);
    }

    const [dynamicRuleLoading, setDynamicRuleLoading] = useState(false)
    const [dynamicRule, setDynamicRule] = useState({})

    const valueFunction = (index) => {
        if (index == 0) return select1
        else if (index == 1) return select2
        else if (index == 2) return select3
        else if (index == 3) return select4
        else if (index == 4) return select5
        else if (index == 5) return select6
        else if (index == 6) return select7
        else if (index == 7) return select8
        else if (index == 8) return select9
        else if (index == 9) return select10
        else if (index == 10) return select11
        else if (index == 11) return select12
        else if (index == 12) return select13
        else if (index == 13) return select14
        else if (index == 14) return select15
        else if (index == 15) return select16
        else if (index == 16) return select17
        else if (index == 17) return select18
        else if (index == 18) return select19
        else if (index == 19) return select20
        else if (index == 20) return select21
        else if (index == 21) return select22
        else if (index == 22) return select23
        else if (index == 23) return select24
        else if (index == 24) return select25
        else if (index == 25) return select26
        else if (index == 26) return select27
        else if (index == 27) return select28
        else if (index == 28) return select29
        else if (index == 29) return select30
        else if (index == 30) return select31
        else if (index == 31) return select32
        else if (index == 32) return select33
        else if (index == 33) return select34
        else if (index == 34) return select35
        else if (index == 35) return select36
    }
    const valueSetFunction = (index) => {
        if (index == 0) return setSelect1
        else if (index == 1) return setSelect2
        else if (index == 2) return setSelect3
        else if (index == 3) return setSelect4
        else if (index == 4) return setSelect5
        else if (index == 5) return setSelect6
        else if (index == 6) return setSelect7
        else if (index == 7) return setSelect8
        else if (index == 8) return setSelect9
        else if (index == 9) return setSelect10
        else if (index == 10) return setSelect11
        else if (index == 11) return setSelect12
        else if (index == 12) return setSelect13
        else if (index == 13) return setSelect14
        else if (index == 14) return setSelect15
        else if (index == 15) return setSelect16
        else if (index == 16) return setSelect17
        else if (index == 17) return setSelect18
        else if (index == 18) return setSelect19
        else if (index == 19) return setSelect20
        else if (index == 20) return setSelect21
        else if (index == 21) return setSelect22
        else if (index == 22) return setSelect23
        else if (index == 23) return setSelect24
        else if (index == 24) return setSelect25
        else if (index == 25) return setSelect26
        else if (index == 26) return setSelect27
        else if (index == 27) return setSelect28
        else if (index == 28) return setSelect29
        else if (index == 29) return setSelect30
        else if (index == 30) return setSelect31
        else if (index == 31) return setSelect32
        else if (index == 32) return setSelect33
        else if (index == 33) return setSelect34
        else if (index == 34) return setSelect35
        else if (index == 35) return setSelect36
    }

    return (
        <Fragment>
            <Box mt={4} sx={sx}>
                <Typography variant="h5">
                    {props.rule.name}
                </Typography>
                &nbsp;
                {props.rule.help && <Help url={props.rule.help} title={props.rule.description} />}
                {dynamicRule && dynamicRule.help && <Help url={dynamicRule.help} title={dynamicRule.type} />}

            </Box>

            {errorMsg &&
                <Box mt={2} sx={sx}>
                    <Typography variant="h5" style={{ color: "red" }}>
                        {errorMsg}
                    </Typography>
                </Box>
            }

            {props.rule.type.includes('.') &&
                <Box>
                    {dynamicRuleLoading && <Box m={3}>
                        <CircularProgress /></Box>}
                    {!dynamicRuleLoading && dynamicRule.input && dynamicRule.input.map((m, index) => (
                        <EachInput {...{
                            m, index, handleOnChange, handleOnChangeCheckbox, valueSetFunction,
                            valueFunction, sketchJson, targetNode, onLoad
                        }} />
                    ))}
                </Box>
            }

            {!props.rule.type.includes('.') && props.rule.input &&
                <Box>
                    {props.rule.input.map((m, index) => (
                        <EachInput {...{
                            m, index, handleOnChange, handleOnChangeCheckbox, valueSetFunction,
                            valueFunction, sketchJson, targetNode, onLoad
                        }} />
                    ))}
                </Box>
            }

            {props.rule.type == 'targetComponent' &&
                <Box mt={1} sx={sx}>
                    <NodeUdidSelectInput label="Root Node"
                        selectableJsonDepth={1}
                        value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} />
                </Box>
            }

            {props.rule.type == 'mappingImage' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="Data Json Path" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <FormControlLabel
                            control={<Checkbox color="primary"
                                checked={select3 == 'Y'}
                                onChange={(e) => handleOnChangeCheckbox(e, setSelect3)}
                            />}
                            label="Local Image"
                            labelPlacement="end"
                        />
                    </Box>

                    <Box mt={1} sx={sx}>

                        <FormControl >
                            <InputLabel>Type</InputLabel>
                            <Select
                                value={select4 ? select4 : 'center_crop'}
                                label={'Scale Type'}
                                defaultValue={'center_crop'}
                                onChange={(e) => handleOnChange(e, setSelect4)}
                            >
                                <MenuItem value={'center_crop'}>Default(Center Crop)</MenuItem>
                                <MenuItem value={'center_inside'}>Center Inside</MenuItem>
                                <MenuItem value={'wrap_height'}>Wrap Height</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    <Box mt={1} sx={sx}>
                        <FormControlLabel
                            control={<Checkbox color="primary"
                                checked={select6 == 'Y'}
                                onChange={(e) => handleOnChangeCheckbox(e, setSelect6)}
                            />}
                            label="Zoomable"
                            labelPlacement="end"
                        />
                    </Box>
                    
                    <Box mt={1} sx={sx}>
                        <TextField label="Flip Image Json Path" value={select5} onChange={(e) => handleOnChange(e, setSelect5)} />
                    </Box>

                </Box>
            }

            {props.rule.type == 'mappingText' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="Data Json Path" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} />
                    </Box>

                    <Box >
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Advanced Setting</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box >
                                    <Box sx={sx}>
                                        <TextField label="Max Line" type="number" min={1} max={100} value={select3} onChange={(e) => handleOnChange(e, setSelect3)} />
                                    </Box>

                                    <FormControlLabel
                                        control={<Checkbox color="primary"
                                            checked={select4 == 'Y'}
                                            onChange={(e) => handleOnChangeCheckbox(e, setSelect4)}
                                        />}
                                        label="Stroke"
                                        labelPlacement="end"
                                    />

                                    <FormControlLabel
                                        control={<Checkbox color="primary"
                                            checked={select5 == 'Y'}
                                            onChange={(e) => handleOnChangeCheckbox(e, setSelect5)}
                                        />}
                                        label="Text Selection for Copy"
                                        labelPlacement="end"
                                    />

                                    <Box mt={1} sx={sx}>
                                        <TextField label="Highlight text Data Json Path" value={select6} onChange={(e) => handleOnChange(e, setSelect6)} />
                                    </Box>

                                    <Box mt={1} sx={sx}>
                                        <TextField label="Highlight text Color(#ffffff)" value={select7} onChange={(e) => handleOnChange(e, setSelect7)} />
                                    </Box>


                                    <Box mt={1} sx={sx}>
                                        <TextField label="Dynamic Text Size Variable - Jevil.get(Variable)" value={select8} onChange={(e) => handleOnChange(e, setSelect8)} />
                                    </Box>

                                    <FormControlLabel
                                        control={<Checkbox color="primary"
                                            checked={select9 == 'Y'}
                                            onChange={(e) => handleOnChangeCheckbox(e, setSelect9)}
                                        />}
                                        label="Ward Wrap"
                                        labelPlacement="end"
                                    />
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    </Box>


                </Box>
            }

            {props.rule.type == 'mappingClick' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>
                    {(select3 == 'action') &&
                        <Box mt={1} sx={sx}>
                            <TextField label="Action" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} fullWidth={true} />
                        </Box>
                    }
                    {(select3 == 'javascript' || !select3) &&
                        <Box mt={1} fullWidth={true}>

                            <AceEditor
                                width={'100%'}
                                placeholder="Code For Click"
                                mode="javascript"
                                theme="github"
                                name="blah2"
                                onLoad={onLoad}
                                onChange={newValue => { setSelect4(newValue) }}
                                fontSize={14}
                                showPrintMargin={true}
                                showGutter={true}
                                highlightActiveLine={true}
                                value={select4}
                                setOptions={{
                                    enableBasicAutocompletion: false,
                                    enableLiveAutocompletion: false,
                                    enableSnippets: false,
                                    showLineNumbers: true,
                                    tabSize: 2,
                                }} />

                        </Box>
                    }

                    <Box mt={1} sx={sx}>
                        <FormControlLabel
                            control={<Checkbox color="primary"
                                checked={select5 == 'Y'}
                                onChange={(e) => handleOnChangeCheckbox(e, setSelect5)}
                            />}
                            label="Disable Click Effect"
                            labelPlacement="end"
                        />
                    </Box>

                    <Box mt={1}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="ga-content"
                                id="ga-header"
                            >
                                <Typography>Advanced Setting</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Box mt={1} sx={sx}>
                                        <TextField label="Accessibility Text Data Json Path" value={select6} onChange={(e) => handleOnChange(e, setSelect6)} />
                                    </Box>

                                    <Box mt={1} sx={sx}>
                                        <TextField label="GA Click Event Name" value={select7} onChange={(e) => handleOnChange(e, setSelect7)} />
                                    </Box>

                                    <Box mt={1} sx={sx}>
                                        <TextField label="GA Data json path" value={select8} onChange={(e) => handleOnChange(e, setSelect8)} />
                                    </Box>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                </Box>
            }

            {props.rule.type == 'layout' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        Align
                        &nbsp;&nbsp;
                        <ToggleButtonGroup
                            value={select2}
                            exclusive
                            onChange={(e, v) => handleOnChange(e, setSelect2, v)}
                        >
                            {[{ v: '0', icon: () => (<FormatAlignLeftIcon />), },
                            { v: '1', icon: () => (<FormatAlignCenterIcon />), },
                            { v: '2', icon: () => (<FormatAlignRightIcon />), }].map(m => (
                                <ToggleButton key={m.v} value={m.v}>
                                    {m.icon()}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                        &nbsp;
                        <ToggleButtonGroup
                            value={select3}
                            exclusive
                            onChange={(e, v) => handleOnChange(e, setSelect3, v)}
                        >
                            {[{ v: '0', icon: () => (<VerticalAlignTopIcon />), },
                            { v: '1', icon: () => (<VerticalAlignCenterIcon />), },
                            { v: '2', icon: () => (<VerticalAlignBottomIcon />), }].map(m => (
                                <ToggleButton key={m.v} value={m.v}>
                                    {m.icon()}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </Box>
                    <Box mt={1} sx={sx}>
                        Variable Width or Height
                        &nbsp;&nbsp;
                        <FormControlLabel
                            control={<Checkbox color="primary"
                                checked={select4 == 'Y'}
                                onChange={(e) => handleOnChangeCheckbox(e, setSelect4)}
                            />}
                            label={<Box sx={sx}>Wrap Content(Horizontal)<SwapHorizontalCircleIcon /></Box>}
                            labelPlacement="end"
                        />

                        &nbsp;
                        <FormControlLabel
                            control={<Checkbox color="primary"
                                checked={select5 == 'Y'}
                                onChange={(e) => handleOnChangeCheckbox(e, setSelect5)}
                            />}
                            label={<Box sx={sx}>Wrap Content(Vertical)<SwapVerticalCircleIcon /></Box>}
                            labelPlacement="end"
                        />

                        &nbsp;
                        <FormControlLabel
                            control={<Checkbox color="primary"
                                checked={select16 == 'Y'}
                                onChange={(e) => handleOnChangeCheckbox(e, setSelect16)}
                            />}
                            label={<Box sx={sx}>Match Parent(Vertical)<SwapVerticalCircleIcon /></Box>}
                            labelPlacement="end"
                        />
                    </Box>

                    <Box mt={1}>
                        <NodeSelectInput label="Relatively right to" value={select6} onChange={(v) => handleOnChange(null, setSelect6, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1}>
                        <NodeSelectInput label="Relatively below to" value={select7} onChange={(v) => handleOnChange(null, setSelect7, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1}>
                        <NodeSelectInput label="Relatively left to" value={select15} onChange={(v) => handleOnChange(null, setSelect15, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1} >
                        <TextField label="Relative Margin" type="number" value={select8} onChange={(e) => handleOnChange(e, setSelect8)} />
                    </Box>

                    <Box mt={1} >
                        <TextField label="Padding Left" type="number" value={select9} onChange={(e) => handleOnChange(e, setSelect9)} />
                        <TextField label="Padding Right" type="number" value={select10} onChange={(e) => handleOnChange(e, setSelect10)} />
                        <TextField label="Padding Top" type="number" value={select11} onChange={(e) => handleOnChange(e, setSelect11)} />
                        <TextField label="Padding Bottom" type="number" value={select12} onChange={(e) => handleOnChange(e, setSelect12)} />
                    </Box>

                    <Box mt={1} >
                        <TextField label="Margin Right" type="number" value={select13} onChange={(e) => handleOnChange(e, setSelect13)} />
                        <TextField label="Margin Bottom" type="number" value={select14} onChange={(e) => handleOnChange(e, setSelect14)} />
                    </Box>
                </Box>
            }

            {props.rule.type == 'repeat' &&
                <Box>
                    <Box mt={1}>
                        <NodeSelectInput label="Repeat Node 0" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>


                    <Box mt={1} sx={sx}>
                        Repeat Type
                        &nbsp;&nbsp;
                        <ToggleButtonGroup
                            value={select2}
                            exclusive
                            onChange={(e, v) => handleOnChange(e, setSelect2, v)}
                        >
                            {[{ v: '0', icon: () => (<Box sx={sx}><ArrowForwardIcon />Right</Box>), },
                            { v: '1', icon: () => (<Box sx={sx}><ArrowDownwardIcon />Bottom</Box>), },
                            { v: '2', icon: () => (<Box sx={sx}><GridOnIcon />Grid</Box>), }, ,
                            { v: '3', icon: () => (<Box sx={sx}><ViewArrayIcon />View Pager</Box>), },
                            { v: '4', icon: () => (<Box sx={sx}><ViewColumnIcon />H List</Box>), },
                            { v: '5', icon: () => (<Box sx={sx}><DnsIcon />List</Box>), },
                            { v: '6', icon: () => (<Box sx={sx}><LabelIcon />Chip</Box>), },
                            ].map(m => (
                                <ToggleButton key={m.v} value={m.v}>
                                    {m.icon()}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </Box>
                    <Box mt={1} sx={sx}>
                        <JsonPathInput label='Repeat Data Json Path' value={select3} onChange={(e) => handleOnChange(e, setSelect3)} />
                    </Box>

                    {(select2 == '0' || select2 == '1' || select2 == '4' || select2 == '6') &&
                        <Box mt={1} >
                            <TextField label="Margin between cell" type="number" value={select4} onChange={(e) => handleOnChange(e, setSelect4)} />
                        </Box>
                    }

                    {(select2 == '2') &&
                        <Box mt={1} >
                            <FormControlLabel
                                control={<Checkbox color="primary"
                                    checked={select5 == 'Y'}
                                    onChange={(e) => handleOnChangeCheckbox(e, setSelect5)}
                                />}
                                label="Grid inline Draw"
                                labelPlacement="end"
                            />
                        </Box>
                    }
                    {(select2 == '3') &&
                        <Box mt={1} >
                            <FormControlLabel
                                control={<Checkbox color="primary"
                                    checked={select18 == 'Y'}
                                    onChange={(e) => handleOnChangeCheckbox(e, setSelect18)}
                                />}
                                label="Auto Swipe"
                                labelPlacement="end"
                            />

                            <FormControlLabel
                                control={<Checkbox color="primary"
                                    checked={select29 == 'Y'}
                                    onChange={(e) => handleOnChangeCheckbox(e, setSelect29)}
                                />}
                                label="Infinite"
                                labelPlacement="end"
                            />
                        </Box>
                    }

                    {select2 != '0' && select2 != '1' &&
                        <Box mt={1} display="flex">
                            <NodeSelectInput label="Repeat Node 1(#)" value={select6} onChange={(v) => handleOnChange(null, setSelect6, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            <IfExpressInput label="If Condition" value={select7} onChange={(e) => handleOnChange(e, setSelect7)} />
                            <Help url='https://devilappbuilder.tistory.com/5' />
                        </Box>}

                    {select2 != '0' && select2 != '1' &&
                        <Box mt={1} display="flex">
                            <NodeSelectInput label="Repeat Node 2(#)" value={select8} onChange={(v) => handleOnChange(null, setSelect8, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            <IfExpressInput label="If Condition" value={select9} onChange={(e) => handleOnChange(e, setSelect9)} />
                        </Box>}

                    {select2 != '0' && select2 != '1' &&
                        <Box mt={1} display="flex">
                            <NodeSelectInput label="Repeat Node 3(#)" value={select10} onChange={(v) => handleOnChange(null, setSelect10, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            <IfExpressInput label="If Condition" value={select11} onChange={(e) => handleOnChange(e, setSelect11)} />
                        </Box>}

                    {select2 != '0' && select2 != '1' &&
                        <Box mt={1} display="flex">
                            <NodeSelectInput label="Repeat Node 4(#)" value={select14} onChange={(v) => handleOnChange(null, setSelect14, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            <IfExpressInput label="If Condition" value={select15} onChange={(e) => handleOnChange(e, setSelect15)} />
                        </Box>}

                    {select2 != '0' && select2 != '1' &&
                        <Box mt={1} display="flex">
                            <NodeSelectInput label="Repeat Node 5(#)" value={select16} onChange={(v) => handleOnChange(null, setSelect16, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            <IfExpressInput label="If Condition" value={select17} onChange={(e) => handleOnChange(e, setSelect17)} />
                        </Box>}

                    {select2 != '0' && select2 != '1' &&
                        <Box mt={1} display="flex">
                            <NodeSelectInput label="Repeat Node 6(#)" value={select19} onChange={(v) => handleOnChange(null, setSelect19, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            <IfExpressInput label="If Condition" value={select20} onChange={(e) => handleOnChange(e, setSelect20)} />
                        </Box>}

                    {select2 != '0' && select2 != '1' &&
                        <Box mt={1} display="flex">
                            <NodeSelectInput label="Repeat Node 7(#)" value={select23} onChange={(v) => handleOnChange(null, setSelect23, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            <IfExpressInput label="If Condition" value={select24} onChange={(e) => handleOnChange(e, setSelect24)} />
                        </Box>}

                    {select2 != '0' && select2 != '1' &&
                        <Box mt={1} display="flex">
                            <NodeSelectInput label="Repeat Node 8(#)" value={select25} onChange={(v) => handleOnChange(null, setSelect25, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            <IfExpressInput label="If Condition" value={select26} onChange={(e) => handleOnChange(e, setSelect26)} />
                        </Box>}

                    {select2 != '0' && select2 != '1' &&
                        <Box mt={1} display="flex">
                            <NodeSelectInput label="Repeat Node 9(#)" value={select27} onChange={(v) => handleOnChange(null, setSelect27, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            <IfExpressInput label="If Condition" value={select28} onChange={(e) => handleOnChange(e, setSelect28)} />
                        </Box>}

                    {select2 != '0' && select2 != '1' &&
                        <Box mt={1} display="flex">
                            <NodeSelectInput label="Repeat Node 10(#)" value={select30} onChange={(v) => handleOnChange(null, setSelect30, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            <IfExpressInput label="If Condition" value={select31} onChange={(e) => handleOnChange(e, setSelect31)} />
                        </Box>}
                    {select2 != '0' && select2 != '1' &&
                        <Box mt={1} display="flex">
                            <NodeSelectInput label="Repeat Node 11(#)" value={select32} onChange={(v) => handleOnChange(null, setSelect32, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            <IfExpressInput label="If Condition" value={select33} onChange={(e) => handleOnChange(e, setSelect33)} />
                        </Box>}

                    {select2 != '0' && select2 != '1' &&
                        <Box mt={1} display="flex">
                            <NodeSelectInput label="Repeat Node 12(#)" value={select34} onChange={(v) => handleOnChange(null, setSelect34, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            <IfExpressInput label="If Condition" value={select35} onChange={(e) => handleOnChange(e, setSelect35)} />
                        </Box>}

                    {(select2 == '4' || select2 == '5') &&
                        <Box mt={1} >
                            <TextField label="Clip to padding" type="number" value={select12} onChange={(e) => handleOnChange(e, setSelect12)} />
                        </Box>
                    }
                    {(select2 == '6') &&
                        <Box mt={1} >
                            <TextField label="Tag item padding(Left,Right)" type="number" value={select13} onChange={(e) => handleOnChange(e, setSelect13)} />
                        </Box>
                    }

                    {(select2 == '5') &&
                        <Box mt={1} >
                            <FormControlLabel
                                control={<Checkbox color="primary"
                                    checked={select21 == 'Y'}
                                    onChange={(e) => handleOnChangeCheckbox(e, setSelect21)}
                                />}
                                label="Pull To Refresh"
                                labelPlacement="end"
                            />
                        </Box>
                    }

                    {(select2 == '5' && select21 == 'Y') &&
                        <Box mt={1} >
                            <AceEditor
                                width={'100%'}
                                height={'200px'}
                                placeholder="Pull To Refresh Script"
                                mode="javascript"
                                theme="github"
                                name="blah2"
                                onLoad={onLoad}
                                onChange={newValue => { setSelect22(newValue) }}
                                fontSize={14}
                                showPrintMargin={true}
                                showGutter={true}
                                highlightActiveLine={true}
                                value={select22}
                                setOptions={{
                                    enableBasicAutocompletion: false,
                                    enableLiveAutocompletion: false,
                                    enableSnippets: false,
                                    showLineNumbers: true,
                                    tabSize: 2,
                                }} />
                        </Box>
                    }

                    {(select2 == '5') &&
                        <Box mt={1} >
                            <NodeSelectInput label="Sticky Node" value={select36} onChange={(v) => handleOnChange(null, setSelect36, v)} sketchJson={sketchJson} targetNode={targetNode} />
                        </Box>
                    }
                </Box>
            }

            {props.rule.type == 'trigger' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Target Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="Trigger Type" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="Action" value={select3} onChange={(e) => handleOnChange(e, setSelect3)} />
                    </Box>
                </Box>
            }

            {props.rule.type == 'hidden' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Target Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <IfExpressInput label="Hidden Condition" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <IfExpressInput label="Show Condition" value={select3} onChange={(e) => handleOnChange(e, setSelect3)} />
                    </Box>
                </Box>
            }

            {props.rule.type == 'icon' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Target Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <JsonPathInput label="Data json" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} />
                    </Box>
                </Box>
            }

            {props.rule.type == 'mappingColor' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Target Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="Foreground Color" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="Background Color" value={select3} onChange={(e) => handleOnChange(e, setSelect3)} />
                    </Box>
                </Box>
            }

            {props.rule.type == 'mappingReplace' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="Http Json Url" value={select1} onChange={(e) => handleOnChange(e, setSelect1)} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <JsonPathInput label="Response From" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <JsonPathInput label="Bind to" value={select3} onChange={(e) => handleOnChange(e, setSelect3)} />
                    </Box>
                </Box>
            }

            {props.rule.type == 'extension' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        Extension Type
                        &nbsp;&nbsp;
                        <ToggleButtonGroup
                            value={select2}
                            exclusive
                            onChange={(e, v) => handleOnChange(e, setSelect2, v)}
                        >
                            {[{ v: 'billboardpager', icon: () => (<Box sx={sx}><MoreHorizIcon />Page Control</Box>), },
                            // {v:'lottie',icon:()=>(<Box sx={sx}><TextRotationAngleupIcon/>Lottie</Box>),},,
                            { v: 'input', icon: () => (<Box sx={sx}><InputIcon />Input</Box>), },
                            { v: 'checkbox', icon: () => (<Box sx={sx}><CheckBoxIcon />CheckBox</Box>), },
                            { v: 'progressBar', icon: () => (<Box sx={sx}><SignalCellular1BarIcon />Progress Bar</Box>), },
                            { v: 'custom', icon: () => (<Box sx={sx}><CopyrightIcon />Custom</Box>), },
                            ].map(m => (
                                <ToggleButton key={m.v} value={m.v}>
                                    {m.icon()}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Target Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>
                    {select2 == 'billboardpager' &&
                        <Box>
                            <Box mt={1} sx={sx}>
                                <NodeSelectInput label="View Pager Node" value={select3} onChange={(v) => handleOnChange(null, setSelect3, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            </Box>
                            <Box mt={1} sx={sx}>
                                <FormControl >
                                    <InputLabel>Type</InputLabel>
                                    <Select
                                        value={select9 ? select9 : 'pagecontrol'}
                                        label={'Type'}
                                        defaultValue={'pagecontrol'}
                                        onChange={(e) => handleOnChange(e, setSelect9)}
                                    >
                                        <MenuItem value={'pagecontrol'}>Page Control</MenuItem>
                                        <MenuItem value={'number'}>Number</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                            {select9 != 'number' && <Box>
                                <Box mt={1} sx={sx}>
                                    <TextField label="Circle Size" value={select4} onChange={(e) => handleOnChange(e, setSelect4)} type="number" />
                                </Box>
                                <Box mt={1} sx={sx}>
                                    <TextField label="Circle Distance" value={select5} onChange={(e) => handleOnChange(e, setSelect5)} type="number" />
                                </Box>
                                <Box mt={1} sx={sx}>
                                    <TextField label="Active Circle Color" value={select6} onChange={(e) => handleOnChange(e, setSelect6)} />
                                </Box>
                                <Box mt={1} sx={sx}>
                                    <TextField label="InActive Inner Circle Color" value={select7} onChange={(e) => handleOnChange(e, setSelect7)} />
                                </Box>
                                <Box mt={1} sx={sx}>
                                    <TextField label="InActive Inner Border Color" value={select8} onChange={(e) => handleOnChange(e, setSelect8)} />
                                </Box>
                            </Box>}
                        </Box>
                    }
                    {select2 == 'progressBar' &&
                        <Box>
                            <Box mt={1} sx={sx}>
                                <NodeSelectInput label="Background Bar" value={select3} onChange={(v) => handleOnChange(null, setSelect3, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            </Box>
                            <Box mt={1} sx={sx}>
                                <TextField label="Watch Value(1~100)" value={select4} onChange={(e) => handleOnChange(e, setSelect4)} />
                            </Box>

                            <Box mt={1} sx={sx}>
                                <NodeSelectInput label="Cap Node" value={select5} onChange={(v) => handleOnChange(null, setSelect5, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            </Box>

                            <Box mt={1} sx={sx}>
                                <FormControlLabel
                                    control={<Checkbox color="primary"
                                        checked={select6 == 'Y'}
                                        onChange={(e) => handleOnChangeCheckbox(e, setSelect6)}
                                    />}
                                    label="Drag Enable"
                                    labelPlacement="end"
                                />
                            </Box>

                            {select6 == 'Y' &&
                                <Box mt={1} fullWidth={true}>

                                    <AceEditor
                                        width={'100%'}
                                        height={'200px'}
                                        placeholder="Drag End Code"
                                        mode="javascript"
                                        theme="github"
                                        name="blah2"
                                        onLoad={onLoad}
                                        onChange={newValue => { setSelect7(newValue) }}
                                        fontSize={14}
                                        showPrintMargin={true}
                                        showGutter={true}
                                        highlightActiveLine={true}
                                        value={select7}
                                        setOptions={{
                                            enableBasicAutocompletion: false,
                                            enableLiveAutocompletion: false,
                                            enableSnippets: false,
                                            showLineNumbers: true,
                                            tabSize: 2,
                                        }} />

                                </Box>
                            }

                            {select6 == 'Y' &&
                                <Box mt={1} fullWidth={true}>

                                    <AceEditor
                                        width={'100%'}
                                        height={'200px'}
                                        placeholder="Dragging"
                                        mode="javascript"
                                        theme="github"
                                        name="blah2"
                                        onLoad={onLoad}
                                        onChange={newValue => { setSelect9(newValue) }}
                                        fontSize={14}
                                        showPrintMargin={true}
                                        showGutter={true}
                                        highlightActiveLine={true}
                                        value={select9}
                                        setOptions={{
                                            enableBasicAutocompletion: false,
                                            enableLiveAutocompletion: false,
                                            enableSnippets: false,
                                            showLineNumbers: true,
                                            tabSize: 2,
                                        }} />

                                </Box>
                            }
                            <Box mt={1} sx={sx}>
                                <FormControlLabel
                                    control={<Checkbox color="primary"
                                        checked={select8 == 'Y'}
                                        onChange={(e) => handleOnChangeCheckbox(e, setSelect8)}
                                    />}
                                    label="Vertical(Bottom 0,Up 100)"
                                    labelPlacement="end"
                                />
                            </Box>
                        </Box>
                    }
                    {select2 == 'input' &&
                        <Box>
                            <Box mt={1} sx={sx}>
                                <JsonPathInput label="Data Key" value={select3} onChange={(e) => handleOnChange(e, setSelect3)} />
                            </Box>
                            <Box mt={1} sx={sx}>
                                <FormControlLabel
                                    control={<Checkbox color="primary"
                                        checked={select4 == 'Y'}
                                        onChange={(e) => handleOnChangeCheckbox(e, setSelect4)}
                                    />}
                                    label="Password"
                                    labelPlacement="end"
                                />
                            </Box>

                            <Box >
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography>Advanced Setting</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box mt={1} sx={sx}>
                                            {/* <TextField label="Complete Click Action" value={select5} onChange={(e) => handleOnChange(e, setSelect5)} /> */}
                                            <InputLabel>Complete Click Action</InputLabel>
                                            <AceEditor
                                                width={'100%'}
                                                height={'200px'}
                                                placeholder="Complete Click Action"
                                                mode="javascript"
                                                theme="github"
                                                name="blah2"
                                                onLoad={onLoad}
                                                onChange={newValue => { setSelect5(newValue) }}
                                                fontSize={14}
                                                showPrintMargin={true}
                                                showGutter={true}
                                                highlightActiveLine={true}
                                                value={select5}
                                                setOptions={{
                                                    enableBasicAutocompletion: false,
                                                    enableLiveAutocompletion: false,
                                                    enableSnippets: false,
                                                    showLineNumbers: true,
                                                    tabSize: 2,
                                                }} />
                                        </Box>
                                        <Box mt={1} sx={sx}>
                                            Action Button Type of KeyPad
                                            &nbsp;&nbsp;
                                            <ToggleButtonGroup
                                                value={select6}
                                                exclusive
                                                onChange={(e, v) => handleOnChange(e, setSelect6, v)}
                                            >
                                                {[{ v: 'complete', icon: () => (<Box sx={sx}><MoreHorizIcon />Complete</Box>), },
                                                { v: 'search', icon: () => (<Box sx={sx}><InputIcon />Search</Box>), },
                                                { v: 'next', icon: () => (<Box sx={sx}><CheckBoxIcon />Next</Box>), },
                                                { v: 'enter', icon: () => (<Box sx={sx}><TransitEnterexitIcon />Enter</Box>), },

                                                ].map(m => (
                                                    <ToggleButton key={m.v} value={m.v}>
                                                        {m.icon()}
                                                    </ToggleButton>
                                                ))}
                                            </ToggleButtonGroup>
                                        </Box>
                                        <Box mt={1} sx={sx}>
                                            Input Type
                                            &nbsp;&nbsp;
                                            <ToggleButtonGroup
                                                value={select7}
                                                exclusive
                                                onChange={(e, v) => handleOnChange(e, setSelect7, v)}
                                            >
                                                {[{ v: 'text', icon: () => (<Box sx={sx}><MoreHorizIcon />Text</Box>), },
                                                { v: 'multiline', icon: () => (<Box sx={sx}><FormatAlignLeftIcon />MultiLine</Box>), },
                                                { v: 'number', icon: () => (<Box sx={sx}><InputIcon />Number</Box>), },
                                                { v: 'number_decimal', icon: () => (<Box sx={sx}><InputIcon />Number(Decimal)</Box>), },
                                                { v: 'number_comma', icon: () => (<Box sx={sx}><InputIcon />Number(Comma)</Box>), },
                                                ].map(m => (
                                                    <ToggleButton key={m.v} value={m.v}>
                                                        {m.icon()}
                                                    </ToggleButton>
                                                ))}
                                            </ToggleButtonGroup>
                                        </Box>
                                        {select7 == 'multiline' &&
                                            <Box mt={1} sx={sx}>
                                                <FormControlLabel
                                                    control={<Checkbox color="primary"
                                                        checked={select10 == 'Y'}
                                                        onChange={(e) => handleOnChangeCheckbox(e, setSelect10)}
                                                    />}
                                                    label="Variable Height"
                                                    labelPlacement="end"
                                                />
                                            </Box>
                                        }
                                        {select7 == 'multiline' &&
                                            <Box mt={1} sx={sx}>
                                                <TextField label="Max Lines For Variable Height" type="number" value={select8} onChange={(e) => handleOnChange(e, setSelect8)} />
                                            </Box>
                                        }

                                        <Box mt={1} sx={sx}>
                                            <TextField label="Placeholder Color" value={select9} onChange={(e) => handleOnChange(e, setSelect9)} />
                                        </Box>

                                        <Box mt={1} sx={sx}>
                                            <TextField label="Max Length" value={select12} onChange={(e) => handleOnChange(e, setSelect12)} />
                                        </Box>

                                        <InputLabel>On Text Change Script</InputLabel>
                                            <AceEditor
                                                width={'100%'}
                                                height={'200px'}
                                                placeholder="On Text Change Script"
                                                mode="javascript"
                                                theme="github"
                                                name="blah2"
                                                onLoad={onLoad}
                                                onChange={newValue => { setSelect13(newValue) }}
                                                fontSize={14}
                                                showPrintMargin={true}
                                                showGutter={true}
                                                highlightActiveLine={true}
                                                value={select13}
                                                setOptions={{
                                                    enableBasicAutocompletion: false,
                                                    enableLiveAutocompletion: false,
                                                    enableSnippets: false,
                                                    showLineNumbers: true,
                                                    tabSize: 2,
                                                }} />

                                            <InputLabel>On Focuse Change</InputLabel>
                                            <AceEditor
                                                width={'100%'}
                                                height={'200px'}
                                                placeholder="On Focuse Change"
                                                mode="javascript"
                                                theme="github"
                                                name="blah2"
                                                onLoad={onLoad}
                                                onChange={newValue => { setSelect14(newValue) }}
                                                fontSize={14}
                                                showPrintMargin={true}
                                                showGutter={true}
                                                highlightActiveLine={true}
                                                value={select14}
                                                setOptions={{
                                                    enableBasicAutocompletion: false,
                                                    enableLiveAutocompletion: false,
                                                    enableSnippets: false,
                                                    showLineNumbers: true,
                                                    tabSize: 2,
                                                }} />
                                    </AccordionDetails>
                                </Accordion>
                            </Box>


                        </Box>
                    }
                    {select2 == 'checkbox' &&
                        <Box>
                            <Box mt={1} sx={sx}>
                                <NodeSelectInput label="On Node" value={select3} onChange={(v) => handleOnChange(null, setSelect3, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            </Box>
                            <Box mt={1} sx={sx}>
                                <NodeSelectInput label="Off Node" value={select4} onChange={(v) => handleOnChange(null, setSelect4, v)} sketchJson={sketchJson} targetNode={targetNode} />
                            </Box>
                            <Box mt={1} sx={sx}>
                                <JsonPathInput label="Watch Value" value={select5} onChange={(e) => handleOnChange(e, setSelect5)} />
                            </Box>
                            <Box mt={1} sx={sx}>
                                <TextField label="On Value" value={select6} onChange={(e) => handleOnChange(e, setSelect6)} />
                            </Box>
                            <Box mt={1} sx={sx}>
                                <FormControlLabel
                                    control={<Checkbox color="primary"
                                        checked={select7 == 'Y'}
                                        onChange={(e) => handleOnChangeCheckbox(e, setSelect7)}
                                    />}
                                    label="Default Check"
                                    labelPlacement="end"
                                />
                            </Box>
                            <Box mt={1} sx={sx}>
                                <TextField label="Click Action" value={select8} onChange={(e) => handleOnChange(e, setSelect8)} />
                            </Box>
                        </Box>
                    }
                    {select2 == 'custom' &&
                        <Box>
                            <Box mt={1} sx={sx}>
                                <TextField label="Custom String" value={select3} onChange={(e) => handleOnChange(e, setSelect3)} />
                            </Box>
                        </Box>
                    }
                </Box>
            }

            {props.rule.type == 'mappingTablet' &&
                <Box mt={1} sx={sx}>
                    <NodeUdidSelectInput label="Tablet Root Node"
                        selectableJsonDepth={1}
                        value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} />
                </Box>
            }

            {props.rule.type == 'web' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="Url" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} />
                    </Box>
                </Box>
            }

            {props.rule.type == 'timer' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="End Action" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} fullWidth={true} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="Start Time Second" type="number" value={select3} onChange={(e) => handleOnChange(e, setSelect3)} />
                    </Box>
                </Box>
            }

            {props.rule.type == 'fix' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Show Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={select3}
                                defaultValue={'qr'}
                                label="Barcode Type"
                                onChange={(e) => handleOnChange(e, setSelect3)}
                            >
                                <MenuItem value={'none'}>None</MenuItem>
                                <MenuItem value={'fadein'}>Fade In by Scroll</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Box>
            }

            {props.rule.type == 'strip' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="View Pager Node" value={select2} onChange={(v) => handleOnChange(null, setSelect2, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="On Node" value={select3} onChange={(v) => handleOnChange(null, setSelect3, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Off Node" value={select4} onChange={(v) => handleOnChange(null, setSelect4, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Selected Under Line" value={select7} onChange={(v) => handleOnChange(null, setSelect7, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <JsonPathInput label='Repeat Data Json Path' value={select5} onChange={(e) => handleOnChange(e, setSelect5)} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <JsonPathInput label='Text Data Json Path' value={select6} onChange={(e) => handleOnChange(e, setSelect6)} />
                    </Box>
                </Box>
            }

            {props.rule.type == 'lottie' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <Dropzone onDrop={acceptedFiles => {
                            if (acceptedFiles.length > 0) {
                                let file = acceptedFiles[0]

                                const reader = new FileReader()
                                reader.onabort = () => console.log('file reading was aborted')
                                reader.onerror = () => console.log('file reading has failed')
                                reader.onload = () => {
                                    const binaryStr = reader.result
                                    let base64Str = Buffer.from(binaryStr).toString('base64')
                                    setFileRaw(base64Str)
                                    setSelect2(file.name)
                                }
                                reader.readAsArrayBuffer(file)
                            }
                        }}>
                            {({ getRootProps, getInputProps }) => (
                                <Box bgcolor="lightgray" p={1}>
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} accept='.json' />
                                        {fileRaw ?
                                            <p>{select2}</p> :
                                            <p>Select Lottie Json file (Get it from https://lottiefiles.com/) </p>
                                        }
                                    </div>
                                </Box>
                            )}
                        </Dropzone>
                    </Box>

                    <Box mt={1} sx={sx}>
                        <FormControlLabel
                            control={<Checkbox color="primary"
                                checked={select3 == 'Y'}
                                onChange={(e) => handleOnChangeCheckbox(e, setSelect3)}
                            />}
                            label="Auto Start"
                            labelPlacement="end"
                        />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <FormControlLabel
                            control={<Checkbox color="primary"
                                checked={select4 == 'Y'}
                                onChange={(e) => handleOnChangeCheckbox(e, setSelect4)}
                            />}
                            label="Repeat Infinite"
                            labelPlacement="end"
                        />
                    </Box>
                </Box>
            }

            {props.rule.type == 'video' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <TextField label="Video Url Data Json Path" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <TextField label="Preview Url Data Json Path" value={select3} onChange={(e) => handleOnChange(e, setSelect3)} />
                    </Box>

                    <FormControlLabel
                        control={<Checkbox color="primary"
                            checked={select4 == 'Y'}
                            onChange={(e) => handleOnChangeCheckbox(e, setSelect4)}
                        />}
                        label="Auto Play"
                        labelPlacement="end"
                    />

                    <FormControlLabel
                        control={<Checkbox color="primary"
                            checked={select5 == 'Y'}
                            onChange={(e) => handleOnChangeCheckbox(e, setSelect5)}
                        />}
                        label="Block Play/Pause Click"
                        labelPlacement="end"
                    />

                    <Box mt={1} sx={sx}>
                        <FormControlLabel
                            control={<Checkbox color="primary"
                                checked={select6 == 'Y'}
                                onChange={(e) => handleOnChangeCheckbox(e, setSelect6)}
                            />}
                            label="Scale Type - Center Inside"
                            labelPlacement="end"
                        />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <FormControlLabel
                            control={<Checkbox color="primary"
                                checked={select7 == 'Y'}
                                onChange={(e) => handleOnChangeCheckbox(e, setSelect7)}
                            />}
                            label="Show Controller"
                            labelPlacement="end"
                        />
                    </Box>
                </Box>
            }

            {props.rule.type == 'qrcode' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <TextField label="QR Data Data Json Path" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Barcode Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={select3}
                                defaultValue={'qr'}
                                label="Barcode Type"
                                onChange={(e) => handleOnChange(e, setSelect3)}
                            >
                                <MenuItem value={'qr'}>Qrcode</MenuItem>
                                <MenuItem value={'bar'}>Barcode</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Box>
            }

            {props.rule.type == 'chat' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="Mqtt Uri ex)tcp://broker.hivemq.com:1883" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="username(optional)" value={select3} onChange={(e) => handleOnChange(e, setSelect3)} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="password(optional)" value={select4} onChange={(e) => handleOnChange(e, setSelect4)} />
                    </Box>

                    <Box mt={1} display="flex">
                        <NodeSelectInput label="Custom Chat Node 1(#)" value={select5} onChange={(v) => handleOnChange(null, setSelect5, v)} sketchJson={sketchJson} targetNode={targetNode} />
                        <IfExpressInput label="If Condition" value={select6} onChange={(e) => handleOnChange(e, setSelect6)} />
                    </Box>

                    <Box mt={1} display="flex">
                        <NodeSelectInput label="Custom Chat Node 2(#)" value={select7} onChange={(v) => handleOnChange(null, setSelect7, v)} sketchJson={sketchJson} targetNode={targetNode} />
                        <IfExpressInput label="If Condition" value={select8} onChange={(e) => handleOnChange(e, setSelect8)} />
                    </Box>

                    <Box mt={1} display="flex">
                        <NodeSelectInput label="Custom Chat Node 3(#)" value={select9} onChange={(v) => handleOnChange(null, setSelect9, v)} sketchJson={sketchJson} targetNode={targetNode} />
                        <IfExpressInput label="If Condition" value={select10} onChange={(e) => handleOnChange(e, setSelect10)} />
                    </Box>

                </Box>
            }

            {props.rule.type == 'calendar' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>
                    <Box mt={1} sx={sx}>
                        <TextField label="List Data Json Path" value={select2} onChange={(e) => handleOnChange(e, setSelect2)} />
                    </Box>
                </Box>
            }

            {props.rule.type == 'address-popup' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>
                </Box>
            }

            {props.rule.type == 'star-rating' &&
                <Box>
                    <Box mt={1} sx={sx}>
                        <NodeSelectInput label="Node" value={select1} onChange={(v) => handleOnChange(null, setSelect1, v)} sketchJson={sketchJson} targetNode={targetNode} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <TextField label="Item Node" value={select4} onChange={(e) => handleOnChange(e, setSelect4)} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <TextField label="Data Json Path" value={select3} onChange={(e) => handleOnChange(e, setSelect3)} />
                    </Box>

                    <Box mt={1} sx={sx}>
                        <FormControlLabel
                            control={<Checkbox color="primary"
                                checked={select2 == 'Y'}
                                onChange={(e) => handleOnChangeCheckbox(e, setSelect2)}
                            />}
                            label="Clickable"
                            labelPlacement="end"
                        />
                    </Box>
                </Box>
            }

            <Box mt={5} >
                <Button variant="outlined" color="primary"
                    startIcon={loadingAdd ? <CircularProgress size={20} /> : <AddCircleOutlineIcon />}
                    disabled={loadingAdd || loadingUpdate}
                    onClick={handleAdd}>Add Rule</Button>
                &nbsp;
                {props.ruleInstance && <Button variant="outlined" color="secondary"
                    startIcon={loadingUpdate ? <CircularProgress size={20} /> : <UpdateIcon />}
                    disabled={loadingAdd || loadingUpdate}
                    onClick={handleUpdate}>Update Rule</Button>}

            </Box>
        </Fragment>
    );
};

export default RulePannel;
